import Clipboard from 'clipboard';

import { showSuccess } from 'utils/messages';

import Base from 'app/views/base';
import ConfirmDisableApiKeyModal from 'app/views/modals/confirm_api_key_disable_modal';

import tmpl from './list_item';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'api-keys-item',

  events: {
    'click .show-key-btn': 'toggleApiKeyVisibility',
    'click .active-status-checkbox': 'toggleStatus',
  },

  initialize() {
    this.confirmDisableApiKeyModal = new ConfirmDisableApiKeyModal({ model: this.model });
  },

  context() {
    return {
      mode: this.model.get('mode'),
      api_key: this.model.get('showProduction') || this.model.get('mode') === 'test' ? this.model.get('key') : '****************',
      show_production: this.model.get('showProduction'),
      key_created_at: this.model.createdAtReadable(),
      active: this.model.get('active'),
      clipboard_text: this.model.get('key'),
    };
  },

  toggleApiKeyVisibility() {
    this.model.set('showProduction', !this.model.get('showProduction'));
    this.render();
  },

  toggleStatus() {
    const activeStatus = this.$('.active-status-checkbox').prop('checked');
    if (activeStatus) {
      // automatically save
      this.model.enableApiKey({
        afterActivateSuccess: () => showSuccess('Your API key is now activated.'),
      });
    } else {
      // show modal for confirmation
      this.confirmDisableApiKeyModal.show();
    }
  },

  afterRender() {
    this.setupCopyApiKey();
  },

  /* eslint no-new: 0 */
  setupCopyApiKey() {
    const copyBtnSelector = '.copy-key-btn';
    new Clipboard(copyBtnSelector);
    this.$(copyBtnSelector).tooltip({ title: 'Copied!', trigger: 'click' });
    this.$(copyBtnSelector).on('shown.bs.tooltip', (e) => {
      const target = e.currentTarget;
      window.setTimeout(() => {
        $(target).tooltip('hide');
      }, 750);
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/api_keys/list_item_view.js